import { reportClientError } from "@cyborg7/observability/web";

const MAX_PANIC_CHARS = 500;

// A panic message can quote a path, a URL or a value: keep the shape, drop the person.
export function scrubPanicText(text: string): string {
  return text
    .replace(/[\w.+-]+@[\w-]+\.[\w.-]+/g, "<email>")
    .replace(/(\/(?:Users|home)\/)[^/\s]+/g, "$1<user>")
    .replace(/([?#])[^\s"')]*/g, "$1<redacted>")
    .replace(/\b(?:bearer\s+)?[A-Za-z0-9_\-.]{32,}\b/gi, "<token>")
    .slice(0, MAX_PANIC_CHARS);
}

export interface PreviousPanic {
  message: string;
  location: string;
}

// The panic the previous launch persisted (src-tauri take_previous_rust_panic), reported
// once: the command deletes the file as it reads it.
export async function reportPreviousRustPanic(
  platform: string,
  take: () => Promise<PreviousPanic | null>,
): Promise<boolean> {
  const panic = await take();
  if (!panic) return false;
  reportClientError({
    source: "tauri.rust_panic",
    message: scrubPanicText(panic.message),
    stack: scrubPanicText(panic.location),
    platform,
    previousLaunch: true,
  });
  return true;
}
